<template>
  <div>
    <v-form ref="form" @submit.prevent="enviar">
      <v-container grid-list-xl fluid style="overflow-y:hidden">
        <!-- CARD DE VIGENCIA DE VIAGEM -->
        <v-card outlined class="app-card">
          <v-card-title class="app-card-title">Período de Vigência da Viagem</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex lg4 sm4 xs12>
                <v-menu
                  ref="menuDataInicio"
                  v-model="menu.inicio"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="190px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="viagem.vigenciaInicial"
                      label="Data de Inicio"
                      :rules="[rules.required]"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="indigo"
                    :min="datas.inicioDataMinima"
                    v-model="datas.dataInicioRaw"
                    no-title
                    @input="menu.inicio = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg4 sm4 xs12>
                <v-menu
                  ref="menuDataFim"
                  v-model="menu.fim"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="190px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="viagem.vigenciaFinal"
                      label="Data de termino"
                      :rules="[rules.required]"
                      persistent-hint
                      readonly
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="indigo"
                    :min="datas.fimDataMinima"
                    v-model="datas.dataFimRaw"
                    no-title
                    @input="menu.fim = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <!--FIM  CARD DE VIGENCIA DE VIAGEM -->

        <!-- INICIO ORIGEM E DESTINO -->
        <v-card class="app-card">
          <v-card-title class="app-card-title">Origem E Destino</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex lg3 sm3 xs12>
                <v-autocomplete
                  v-model="viagem.localidadeOrigem.id"
                  :items="localidades"
                  item-text="nome"
                  item-value="id"
                  color="#01579B"
                  :rules="[rules.required]"
                  label="Localidade origem *"
                ></v-autocomplete>
              </v-flex>

              <v-flex lg3 sm3 xs12>
                <v-menu
                  ref="horaSaidaOrigem"
                  v-model="menu.saida"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="viagem.horaOrigem"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="250px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="viagem.horaOrigem"
                      label="Horário de saída *"
                      :rules="[rules.required]"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    format="24hr"
                    v-if="menu.saida"
                    v-model="viagem.horaOrigem"
                    full-width
                    @click:minute="
                      $refs.horaSaidaOrigem.save(viagem.horaOrigem)
                    "
                  ></v-time-picker>
                </v-menu>
              </v-flex>

              <v-flex lg3 sm3 xs12>
                <v-autocomplete
                  v-model="viagem.localidadeDestino.id"
                  :items="localidades"
                  color="#01579B"
                  :rules="[rules.required]"
                  item-text="nome"
                  item-value="id"
                  label="Localidade destino *"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 sm3 xs12>
                <v-menu
                  ref="horaSaidaDestino"
                  v-model="menu.destino"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="viagem.horaDestino"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="250px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="viagem.horaDestino"
                      label="Horário de saída *"
                      :rules="[rules.required]"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    format="24hr"
                    v-if="menu.destino"
                    v-model="viagem.horaDestino"
                    full-width
                    @click:minute="
                      $refs.horaSaidaDestino.save(viagem.horaDestino)
                    "
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <!--FIM ORIGEM E DESTINO -->
      </v-container>
      <v-divider style="margin-left: 0px !important; margin-right: 0px !important;"></v-divider>
      <v-card-actions class="app-card-actions">
        <v-btn small @click="closeDialog" depressed color="error">Cancelar</v-btn>
        <v-btn small type="submit" depressed color="#3eb355" class="white--text">Confirmar</v-btn>
      </v-card-actions>
    </v-form>

    <!-- SPINNER DE LOAD -->
    <v-dialog v-model="spiner.novaViagemOpen" overlay-opacity="0" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Cadastrando nova viagem
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- FIM SPINNER DE LOAD -->
  </div>
</template>

<script>
import moment from "moment";
import GlobalStore from "@/store/modules/global";

import LocalidadeService from "@/services/localidade.service";
import ViagemService from "@/services/viagem.service";

export default {
  name: "ViagemForm",
  props: {
    viagemEdit: {
      type: Object,
      default: null
    },
    autorizacaoId: {
      required: true
    }
  },
  data() {
    return {
      menu: {},
      spiner: {
        novaViagemOpen: false
      },
      viagem: {
        id: null,
        vigenciaInicial: null,
        vigenciaFinal: null,
        horaOrigem: null,
        horaDestino: null,
        viproc: null,
        trechosViagem: [],
        localidadeOrigem: {},
        localidadeDestino: {},
        autorizacaoFretamento: {}
      },
      datas: {
        dataInicioRaw: null,
        inicioDataMinima: null,
        dataFimRaw: null,
        fimDataMinima: null
      },
      localidades: [],
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido"
      }
    };
  },
  methods: {
    iniciarPaginaInserir() {
      this.viagem.autorizacaoFretamento.id = this.autorizacaoId;
      this.viagem.id = null;
      this.viagem.vigenciaInicial = this.dataAtualFormatada();
      this.datas.inicioDataMinima = new Date().toISOString().substr(0, 10);
      this.datas.dataInicioRaw = new Date().toISOString().substr(0, 10);
      this.viagem.vigenciaFinal = this.dataAtualFormatada();
      this.datas.fimDataMinima = new Date().toISOString().substr(0, 10);
    },
    iniciarPaginaAlterar() {
      const {
        id,
        inicioVigencia,
        fimVigencia,
        horaOrigem,
        horaDestino,
        trechos,
        trechosViagem,
        localidadeOrigem,
        localidadeDestino,
        autorizacaoFretamento: { id: autorizacao }
      } = this.viagemEdit;

      if (trechos.length > 0) {
        trechos.forEach(element => {
          element.passageiros.forEach(passageiro => {
            const { dataEmissaoDocumento, dataValidadeDocumento } = passageiro;
            passageiro.dataEmissaoDocumento = null;
            passageiro.dataValidadeDocumento = null;

            passageiro.dataEmissaoDocumentoStr = dataEmissaoDocumento;
            passageiro.dataValidadeDocumentoStr = dataValidadeDocumento;
          });
        });
      }

      this.viagem.id = id;
      this.viagem.vigenciaInicial = inicioVigencia;
      this.viagem.vigenciaFinal = fimVigencia;
      this.viagem.horaOrigem = horaOrigem;
      this.viagem.horaDestino = horaDestino;
      this.viagem.trechosViagem = trechos;
      this.viagem.localidadeOrigem = localidadeOrigem;
      this.viagem.localidadeDestino = localidadeDestino;
      this.viagem.autorizacaoFretamento.id = autorizacao;
    },
    formatarData(data) {
      return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    dataAtualFormatada() {
      return moment(new Date(), "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    carregarLocalidade() {
      LocalidadeService.findAll().subscribe(
        response => {
          const { localidades } = response;
          this.localidades = localidades;
        },
        err => {
          this.exibirMensagem("Erro ao buscar localidades", "error");
        }
      );
    },
    enviar(event) {
      let isValid = this.$refs.form.validate();

      if (isValid) {
        this.spiner.novaViagemOpen = true;
        ViagemService.create(this.viagem).subscribe(
          response => {
            const { resultado } = response;

            if (resultado == 200) {
              this.exibirMensagem("Operação realizada com sucesso", "success");
              this.spiner.novaViagemOpen = false;
              this.$emit("recarregarListaViagens");
              this.$refs.form.reset();
              this.iniciarPaginaInserir();
            } else {
              const { mensagemNegocio } = response;
              this.spiner.novaViagemOpen = false;
              this.exibirMensagem(mensagemNegocio, "error");
            }
          },
          err => {
            this.spiner.novaViagemOpen = false;
            this.exibirMensagem(mensagemNegocio, "error");
          }
        );
      }
    },
    closeDialog() {
      this.$emit("closeDialogFormViagem");
    },
    exibirMensagem(mensagem, tipoMensagem) {
      GlobalStore.setSnackBar({
        show: true,
        message: mensagem,
        type: tipoMensagem,
        timeout: 6000
      });
    }
  },
  watch: {
    "datas.dataInicioRaw"() {
      this.viagem.vigenciaInicial = this.formatarData(this.datas.dataInicioRaw);
    },
    "datas.dataFimRaw"() {
      this.viagem.vigenciaFinal = this.formatarData(this.datas.dataFimRaw);
    }
  },
  mounted() {
    this.carregarLocalidade();
    if (this.viagemEdit.id == null) {
      this.iniciarPaginaInserir();
    } else {
      this.iniciarPaginaAlterar();
    }
  }
  // this.$emit("recarregarListaViagens");
  // this.$refs.form.reset()
  // this.iniciarPaginaInserir()
};
</script>

<style lang="scss" scoped>
.text-info {
  border-bottom: solid 1px #767676;
  width: 100%;
  padding-bottom: 3px;
  display: block;
  strong {
    color: #000;
    font-weight: 800;
    color: #767676;
    text-transform: uppercase;
  }
  span {
    display: table;
    color: #767676;
  }
}
.botao {
  float: right;
}
.btnMore {
  margin-top: 20px;
}
.btnMinus {
  margin-top: 20px;
  margin-left: 2px;
}
fieldset {
  padding: 10px;
  border: none;
  border: solid 1px rgba(0, 0, 0, 0.001);
  legend {
    font-size: 20px;
    font-weight: 500;
    position: relative;
    top: 20px;
    background-color: #ededed;
    width: 100%;
    padding: 5px 10px;
    color: #676767;
    margin-bottom: 15px;
    text-transform: uppercase;

    .v-icon {
      color: #676767;
      position: relative;
      top: -3px;
    }
  }
}
.card-custom-title {
  background-color: darkgrey;
  line-height: 0rem;
  height: 20px;
  font-size: 1em;
}
.space-custom {
  margin-top: 1em;
}
.placa {
  width: 30%;
}
.bg-white {
  background-color: #fff;
}
.btn-submit {
  color: #fff;
  background-color: rgb(66, 179, 84) !important;
  border-color: rgb(66, 179, 84) !important;
  height: 50px !important;
}
</style>
